import LocationConstraint from 'owa-calendar-scheduling-service/lib/schema/LocationConstraint';

/**
 * Create LocationConstraint for FML request
 */
export default function createLocationConstraints(
    coordinates: GeolocationCoordinates
): LocationConstraint {
    if (coordinates) {
        let locationConstraint: LocationConstraint = {
            locations: [
                {
                    coordinates: {
                        Latitude: coordinates.latitude,
                        Longitude: coordinates.longitude,
                    },
                },
            ],
        };

        return locationConstraint;
    } else {
        return null;
    }
}
